module.exports = "/_next/static/images/f5bef58a6f100c57e75e5ad1f36f093b-Nubank_HickDuarte_57380_lg.png.webp";